/* eslint-disable consistent-return */
'use client'

import { RefObject, useEffect } from 'react'
import { hasSpeculationRulesEnabled } from '../../../providers/SpeculationRulesProvider'

export function usePrefetchOnHover(
  ref: RefObject<HTMLAnchorElement>,
  href: string,
  enabled = true
) {
  useEffect(() => {
    if (!enabled || !href) {
      return
    }

    const el = ref.current

    if (!el) {
      return
    }

    const handler = () => {
      if (hasSpeculationRulesEnabled()) {
        el.setAttribute('data-hardlink', 'speculation')
        return
      }

      if (
        window.document.querySelector(`link[rel="prefetch"][href="${href}"]`)
      ) {
        return
      }
      const link = window.document.createElement('link')
      link.rel = 'prefetch'
      link.href = href
      link.as = 'document'
      link.crossOrigin = 'anonymous'
      window.document.head.appendChild(link)

      el.setAttribute('data-hardlink', 'prefetch')
    }

    el.addEventListener('mouseenter', handler)
    return () => {
      el.removeEventListener('mouseenter', handler)
    }
  }, [ref, href, enabled])
}
